export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) return '—'
  if (seconds < 60) return `${Math.round(seconds)}s`
  const minutes = seconds / 60
  if (minutes < 60) {
    const whole = Math.floor(minutes)
    const remainder = Math.round(seconds - whole * 60)
    return remainder === 0 ? `${whole}m` : `${whole}m ${remainder}s`
  }
  const hours = minutes / 60
  if (hours < 24) {
    const whole = Math.floor(hours)
    const remainderMin = Math.round((hours - whole) * 60)
    return remainderMin === 0 ? `${whole}h` : `${whole}h ${remainderMin}m`
  }
  return `${Math.round(hours / 24)}d`
}

export function formatPercent(value: number | null | undefined, digits = 1): string {
  if (value == null) return '—'
  return `${(value * 100).toFixed(digits)}%`
}

export function formatDelta(value: number | null | undefined): string {
  if (value == null) return ''
  const sign = value > 0 ? '+' : ''
  return `${sign}${value.toFixed(1)}%`
}

export function deltaTone(value: number | null | undefined): 'positive' | 'negative' | 'neutral' {
  if (value == null || value === 0) return 'neutral'
  return value > 0 ? 'positive' : 'negative'
}

export function formatInteger(value: number | null | undefined): string {
  if (value == null) return '—'
  return new Intl.NumberFormat().format(Math.round(value))
}
